/** @jsxImportSource @emotion/react */

import { Modal } from "antd";
import ErrorImage from "assets/images/error-image.jpg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PromotionListType } from "types/promotions";

import { CardPromotionStyle } from "./style.index";

const CardPromotion = (props: PromotionListType) => {
  const { t } = useTranslation(["common", "modal"]);
  const { bonus, wager, web, content } = props;
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  return (
    <div css={CardPromotionStyle.wrapper}>
      <img
        src={web}
        alt={t("common:error_image_alt")}
        onError={(e) => {
          (e.target as HTMLImageElement).src = ErrorImage;
        }}
      />
      <div css={CardPromotionStyle.textBox}>
        <h4>{bonus}</h4>
        <p>
          {t("modal:wager")} <span>x{wager}</span>
        </p>
        <div css={CardPromotionStyle.btnDetail.index}>
          <div
            onClick={() => setIsOpenModal(true)}
            css={CardPromotionStyle.btnDetail.animate}
          >
            <span>{t("modal:details_button")}</span>
            <div className="arrow">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <Modal
        onCancel={() => setIsOpenModal(false)}
        centered
        open={isOpenModal}
        footer={null}
        css={CardPromotionStyle.modal}
      >
        <>
          <div css={CardPromotionStyle.bonusModal}>{bonus}</div>
          <div
            css={CardPromotionStyle.contentModal}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </>
      </Modal>
    </div>
  );
};

export default CardPromotion;
